import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {Box, FormControl, InputLabel, NativeSelect, Typography} from "@material-ui/core";

import {setShowModal} from "../../../services/redux/actions/app-actions";
import CustomButton from "../../../components/UI/Button";
import {useCustomSnackbar} from "../../../utils/hooks/useCustomSnackbar";
import {getHunterGrade, getHunterTypes, postHunterGrade} from "../api";

const ChangeGradeModal = ({hunterId, hunterFio, onSaved}) => {
  const dispatch = useDispatch();
  const {addDefaultSnack, addCloseSnack} = useCustomSnackbar();

  const [hunterTypes, setHunterTypes] = useState([]);
  const [history, setHistory] = useState([]);
  const [kpiHunterTypeId, setKpiHunterTypeId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getHunterTypes().then(res => {
      setHunterTypes((res || []).filter(el => el.is_assignable));
    });
  }, []);

  useEffect(() => {
    if (!hunterId) return;
    getHunterGrade(hunterId).then(res => {
      setHistory(res || []);
      const active = (res || []).find(el => el.is_active);
      if (active) setKpiHunterTypeId(active.kpi_hunter_type_id);
    });
  }, [hunterId]);

  const handleChange = e => {
    setKpiHunterTypeId(e.target.value);
  };

  const handleSave = () => {
    if (!kpiHunterTypeId) {
      addCloseSnack("Выберите тип хантера!");
      return;
    }
    setLoading(true);
    postHunterGrade(hunterId, kpiHunterTypeId)
      .then(() => {
        addDefaultSnack("Грейд хантера успешно изменен");
        dispatch(setShowModal(false));
        onSaved && onSaved();
      })
      .catch(() => {
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box sx={{width: 420}}>
      <Box sx={{display: "grid", gap: "10px"}}>
        {hunterFio ? (
          <Typography style={{fontWeight: 600}}>{hunterFio}</Typography>
        ) : null}
        <FormControl style={{minWidth: "200px"}}>
          <InputLabel htmlFor="select-hunter-type" shrink>
            Тип хантера
          </InputLabel>
          <NativeSelect
            value={kpiHunterTypeId}
            onChange={handleChange}
            inputProps={{
              name: "kpi_hunter_type_id",
              id: "select-hunter-type",
            }}
          >
            <option value="" disabled>
              Выберите тип
            </option>
            {hunterTypes.map(el => {
              return (
                <option value={el.kpi_hunter_type_id} key={el.kpi_hunter_type_id}>
                  {el.type_name}
                </option>
              );
            })}
          </NativeSelect>
        </FormControl>

        {history?.length ? (
          <Box>
            <Typography variant="body2" style={{fontWeight: 600, marginBottom: 5}}>
              История грейдов
            </Typography>
            <Box sx={{display: "grid", gap: "4px"}}>
              {history.map(el => (
                <Typography variant="body2" key={el.kpi_hunter_grade_id}>
                  {el.date_from} — {el.kpi_hunter_type_name}
                  {el.is_active ? " (текущий)" : ""}
                  {el.assigned_by_fio ? `, назначил: ${el.assigned_by_fio}` : ""}
                </Typography>
              ))}
            </Box>
          </Box>
        ) : null}
      </Box>
      <Box sx={{width: 200, marginRight: "auto", marginTop: "20px"}}>
        <CustomButton btnText="Сохранить" handleClick={handleSave} loading={loading}/>
      </Box>
    </Box>
  );
};

export default ChangeGradeModal;
